import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getAllProgramsCount = (Condition, Status, ShotClass) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_ALL_PROGRAMS_COUNT(Condition, Status, ShotClass)
  );
};

export default getAllProgramsCount;
